/**
 *
 * LandingPage sagas
 *
 */

import {
    put, takeLatest, take,
} from 'redux-saga/effects';
import _get from 'lodash/get';
import { GET_DATA } from './landing-page-constants';
import { loadTopic } from 'data/topic/topic-actions';
import { loadList, clearListData } from 'data/list/list-actions';
import { LOAD_TOPIC_SUCCESS } from 'data/topic/topic-constants';

export function* getLandingPageData(action) {

    const topicId = action.id;
    yield put(clearListData());
    yield put(loadTopic(topicId));
    const loadTopicAction = yield take(LOAD_TOPIC_SUCCESS);
    const advancedCriteria = _get(loadTopicAction, 'data.advancedCriteria', '');
    const selectionSlug = _get(loadTopicAction, 'data.selection.0.slug', '');

    yield put(loadList(selectionSlug, advancedCriteria));

}


export default function* landingPageData() {

    yield takeLatest(GET_DATA, getLandingPageData);

}
